import { LogLevel } from '@wix/panorama-common-shared/types';
// import { getWixtHttpErrorDetails } from '../utils/error-utils';

const getSessionParams = globalConfig => {
  const sessionId = globalConfig.getSessionId();
  const sessionTime = Math.round(globalConfig.getSessionTime());
  return {
    sessionId,
    sessionTime
  };
};
export const buildTransactionPayload = (globalConfig, baseParams, transactionParams, data) => {
  const {
    transactionName,
    transactionAction
  } = transactionParams;
  const {
    sessionId,
    sessionTime
  } = getSessionParams(globalConfig);
  const logLevel = LogLevel.Info;
  const message = "Panorama " + transactionName + " " + transactionAction;
  // const requestId = '';

  return {
    sessionId,
    sessionTime,
    logLevel,
    // requestId,
    message,
    data,
    ...baseParams,
    ...transactionParams
  };
};
export const buildErrorPayload = (globalConfig, baseParams, error, data) => {
  const {
    sessionId,
    sessionTime
  } = getSessionParams(globalConfig);
  const {
    constructor,
    message,
    stack = ''
  } = error;
  const logLevel = LogLevel.Error;
  // const { requestId } = getWixtHttpErrorDetails(error);

  return {
    sessionId,
    sessionTime,
    logLevel,
    // requestId,
    data,
    errorName: constructor.name,
    errorStack: stack,
    message,
    ...baseParams
  };
};
export const buildLoggerPayload = (globalConfig, baseParams, loggerParams) => {
  const {
    sessionId,
    sessionTime
  } = getSessionParams(globalConfig);
  // const requestId = '';

  return {
    sessionId,
    sessionTime,
    // requestId,
    ...baseParams,
    ...loggerParams
  };
};
//# sourceMappingURL=payload-builder.js.map